import React, { FC } from 'react';

export const SubdomainDetails: FC = () => {
	return <div className="inline-block flex-grow-1">{/* Content here */}</div>;
};
